
import { EndpointScenarioMap } from './mock.types';

interface LoanResponse {
  success: boolean;
  data: {
    loanId: string;
    loanType: string;
    loanNumber?: string;
    loanOfficerId?: string;
    hasSubmit?: boolean;
  };
}

interface BorrowerResponse {
  success: boolean;
  data: {
    borrowerId: string;
    loanId: string;
    firstName: string;
    lastName: string;
    email: string;
    isPrimary: boolean;
    dob?: string;
  };
}

interface IncomeResponse {
  success: boolean;
  data: {
    incomeId: string;
    borrowerId: string;
    incomeSource: string;
    employerName?: string;
    jobTitle?: string;
    monthlyIncome: number;
  };
}

interface AssetResponse {
  success: boolean;
  data: {
    assetId: string;
    borrowerId: string;
    institutionName: string;
    accountType: string;
    balance: number;
  };
}

interface UpdateResponse {
  success: boolean;
}

export const createLoanScenarios: EndpointScenarioMap<LoanResponse> = {
  default: {
    success: true,
    data: {
      loanId: 'loan-new-001',
      loanType: 'Purchase',
      loanNumber: 'P-2024-001234',
      hasSubmit: false,
    },
  },
  'with-loan-officer': {
    success: true,
    data: {
      loanId: 'loan-new-002',
      loanType: 'Purchase',
      loanNumber: 'P-2024-001235',
      loanOfficerId: 'lo-001',
      hasSubmit: false,
    },
  },
  error: {
    success: false,
    data: {
      loanId: '',
      loanType: '',
    },
  },
};

export const updateLoanScenarios: EndpointScenarioMap<UpdateResponse> = {
  default: {
    success: true,
  },
  error: {
    success: false,
  },
};

export const createBorrowerScenarios: EndpointScenarioMap<BorrowerResponse> = {
  default: {
    success: true,
    data: {
      borrowerId: 'borrower-new-001',
      loanId: 'loan-new-001',
      firstName: 'Test',
      lastName: 'User',
      email: 'test.user@example.com',
      isPrimary: true,
    },
  },
  'with-dob': {
    success: true,
    data: {
      borrowerId: 'borrower-new-002',
      loanId: 'loan-new-001',
      firstName: 'John',
      lastName: 'Smith',
      email: 'john.smith@example.com',
      isPrimary: true,
      dob: '1985-06-15',
    },
  },
  'co-borrower': {
    success: true,
    data: {
      borrowerId: 'borrower-new-003',
      loanId: 'loan-new-001',
      firstName: 'Jane',
      lastName: 'Smith',
      email: 'jane.smith@example.com',
      isPrimary: false,
    },
  },
  error: {
    success: false,
    data: {
      borrowerId: '',
      loanId: '',
      firstName: '',
      lastName: '',
      email: '',
      isPrimary: false,
    },
  },
};

export const updateBorrowerScenarios: EndpointScenarioMap<UpdateResponse> = {
  default: {
    success: true,
  },
  error: {
    success: false,
  },
};

export const createIncomeScenarios: EndpointScenarioMap<IncomeResponse> = {
  default: {
    success: true,
    data: {
      incomeId: 'income-new-001',
      borrowerId: 'borrower-new-001',
      incomeSource: 'Employed',
      employerName: 'Acme Corporation',
      jobTitle: 'Software Engineer',
      monthlyIncome: 8500,
    },
  },
  'self-employed': {
    success: true,
    data: {
      incomeId: 'income-new-002',
      borrowerId: 'borrower-new-001',
      incomeSource: 'SelfEmployed',
      employerName: 'Self',
      jobTitle: 'Consultant',
      monthlyIncome: 12000,
    },
  },
  pension: {
    success: true,
    data: {
      incomeId: 'income-new-003',
      borrowerId: 'borrower-new-001',
      incomeSource: 'Pension',
      monthlyIncome: 3500,
    },
  },
  error: {
    success: false,
    data: {
      incomeId: '',
      borrowerId: '',
      incomeSource: '',
      monthlyIncome: 0,
    },
  },
};

export const updateIncomeScenarios: EndpointScenarioMap<UpdateResponse> = {
  default: {
    success: true,
  },
  error: {
    success: false,
  },
};

export const deleteIncomeScenarios: EndpointScenarioMap<UpdateResponse> = {
  default: {
    success: true,
  },
  error: {
    success: false,
  },
};

export const createAssetScenarios: EndpointScenarioMap<AssetResponse> = {
  default: {
    success: true,
    data: {
      assetId: 'asset-new-001',
      borrowerId: 'borrower-new-001',
      institutionName: 'Chase Bank',
      accountType: 'Checking',
      balance: 25000,
    },
  },
  savings: {
    success: true,
    data: {
      assetId: 'asset-new-002',
      borrowerId: 'borrower-new-001',
      institutionName: 'Bank of America',
      accountType: 'Savings',
      balance: 50000,
    },
  },
  retirement: {
    success: true,
    data: {
      assetId: 'asset-new-003',
      borrowerId: 'borrower-new-001',
      institutionName: 'Fidelity',
      accountType: 'Four01K',
      balance: 150000,
    },
  },
  error: {
    success: false,
    data: {
      assetId: '',
      borrowerId: '',
      institutionName: '',
      accountType: '',
      balance: 0,
    },
  },
};

export const updateAssetScenarios: EndpointScenarioMap<UpdateResponse> = {
  default: {
    success: true,
  },
  error: {
    success: false,
  },
};

export const deleteAssetScenarios: EndpointScenarioMap<UpdateResponse> = {
  default: {
    success: true,
  },
  error: {
    success: false,
  },
};

export const submitApplicationScenarios: EndpointScenarioMap<UpdateResponse> = {
  default: {
    success: true,
  },
  error: {
    success: false,
  },
};
